import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatDialogModule } from '@angular/material/dialog';

import { UiIconModule } from '@cigna/shared/angular/icon-ui';
import { UiButtonModule } from '@cigna/shared/angular/button-ui';

import { ResourcesModalComponent } from './resources-modal/resources-modal.component';
import { ResourcesUiComponent } from './resources-ui/resources-ui.component';
import { VideoDialogLoaderComponent } from './video-dialog-loader/video-dialog-loader.component';

@NgModule({
  imports: [CommonModule, UiIconModule, UiButtonModule, MatDialogModule],
  declarations: [
    VideoDialogLoaderComponent,
    ResourcesModalComponent,
    ResourcesUiComponent,
  ],
  exports: [
    VideoDialogLoaderComponent,
    ResourcesModalComponent,
    ResourcesUiComponent,
  ],
})
export class ChcpResourcesStaticUiModule {}
